<div class="modal-header">
  <h5 class="modal-title" id="modal-basic-title">
    <img src="assets/statusIncomplete.svg" />
    Warning: invalid fields
  </h5>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="modal.dismiss('Close')"
  >
    <img src="assets/close.svg" />
  </button>
</div>
<div class="modal-body p-0" ngbAutofocus>
  <ul class="list-group">
    <ng-container *ngFor="let field of fields">
      <li class="list-group-item list-group-item-action ml-0">
        <button
          class="text-primary"
          type="button"
          (click)="navigateField(field.path)"
        >
          {{ field.label }}
        </button>
      </li>
    </ng-container>
  </ul>
</div>
